import { TURN_PHASES } from '../../hooks/useWSTurnState';

// Constantes para tamanhos das câmeras no welcome flow
export const WELCOME_CAMERA_SCALES = {
  normal: 1.2,      // Tamanho natural 10% maior
  minimized: 1    // Tamanho reduzido em GroundRules
};

// Variants para animação de retração/expansão das câmeras
export const cameraVariants = {
  normal: { scale: 1, y: 0 },
  minimized: {
    scale: 0.6,
    y: 40,
    transition: { duration: 0.6, ease: "easeInOut" }
  }
};

const formatLabel = (label) => {
  const safe = typeof label === 'string' ? label : '';
  if (!safe.trim()) return null;
  return safe
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getPhaseTexts = ({
  phase,
  participantALabel,
  participantBLabel,
}) => {
  const formattedA = formatLabel(participantALabel) || 'Participant A';
  const formattedB = formatLabel(participantBLabel) || 'Participant B';

  switch (phase) {
    case TURN_PHASES.Welcome:
      return {
        title: "Welcome to our English practice!",
        subtitle: "Let's practice together!"
      };
    case TURN_PHASES.GroundRules:
      return {
        title: "Ground Rules",
        subtitle: "",
        items: [
          "Speak only in English",
          "Be patient, this is a learning space",
          "Be curious about your partner"
        ]
      };
    case TURN_PHASES.SelfIntroductions:
      return {
        title: "Self Introductions",
        subtitle: "We’ll start with short introductions, one at a time."
      };
    case TURN_PHASES.SelfIntroductionsA:
      return {
        title: `Self Introduction - ${formattedA}`,
        subtitle: `${formattedA}, you can start when you're ready.`
      };
    case TURN_PHASES.SelfIntroductionsAtoB:
      return {
        title: `Next: ${formattedB}`,
        subtitle: `${formattedB}, your turn is coming up.`
      };
    case TURN_PHASES.SelfIntroductionsB:
      return {
        title: `Self Introduction - ${formattedB}`,
        subtitle: `${formattedB}, you can start when you're ready.`
      };
    case TURN_PHASES.SelfIntroductionsDone:
      return {
        title: "Alright!",
        subtitle: "Now let’s move on to today’s theme."
      };
    default:
      return {
        title: "Welcome to our English practice!",
        subtitle: "Let's practice English together!"
      };
  }
};

